export const API_EXTERNAL_ENDPOINT = 'users/signUp'

export const API_INTERNAL_ENDPOINT = 'rurality/v3/users/sign-up'
